import { render } from "./AdminDashboard.vue?vue&type=template&id=b71d6f76&scoped=true"
import script from "./AdminDashboard.vue?vue&type=script&lang=js"
export * from "./AdminDashboard.vue?vue&type=script&lang=js"

import "./AdminDashboard.vue?vue&type=style&index=0&id=b71d6f76&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/drk-hurricane.de/test-helfer.drk-hurricane.de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b71d6f76"]])

export default __exports__